import { useMemo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTable, usePagination, useGlobalFilter, useAsyncDebounce, useSortBy } from "react-table";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDPagination from "components/MDPagination";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import { Box, Button, Input, Pagination } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MDDatePicker from "components/MDDatepicker";
import { LuArrowUpDown, LuArrowDown, LuArrowUp } from "react-icons/lu";
import MDTimePicker from "components/MDTimepicker";
import colors from "assets/theme/base/colors";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { MdDragIndicator } from "react-icons/md";
const { info } = colors;

function DataTable({
  // entriesPerPage,
  showEntriesPerPage = true,
  canSearch,
  showTotalEntries,
  isClearAllFilter,
  table,
  pagination,
  clearAllFilters,
  isSorted,
  tableTitle,
  noEndBorder,
  isDraggable,
  updateApi,
  getDataList,
  rowCount,
  defaultFilter,
  setDefaultFilter,
  showRowPaginationOptions = true,
}) {
  // const defaultValue = entriesPerPage.defaultValue ? entriesPerPage.defaultValue : 10;
  const columns = useMemo(() => table.columns, [table]);
  const data = useMemo(() => table.rows, [table]);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const tableInstance = useTable(
    { columns, data, initialState: { pageIndex: currentPageIndex } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    pageOptions,
    canPreviousPage,
    canNextPage,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const entries = ["5", "10", "15", "20", "25", "50", "100"];

  // Calculate total pages based on rowCount
  const [rowsData, setRowsData] = useState(table);
  const [currentSelectedPage, setCurrentSelectedPage] = useState(defaultFilter?.currentPage);

  useEffect(() => {
    setRowsData(table); // Update rowsData when rows change
  }, [table]);

  const handleEntriesChange = (event, newValue) => {
    const newPageSize = parseInt(newValue, 10);
    setEntriesPerPage(newPageSize);
    setPageSize(newPageSize);
    setDefaultFilter((value) => ({
      ...value,
      currentPage: 1,
      itemsPerPage: newPageSize,
    }));
  };

  const handlePageChange = (event, newPage) => {
    if (newPage !== currentPage) {
      setCurrentSelectedPage(newPage);
      setDefaultFilter((prev) => ({ ...prev, currentPage: newPage }));
    }
  };

  const { currentPage, itemsPerPage } = defaultFilter || {};
  const totalRecords = rowCount;
  const entriesStart = (currentPage - 1) * itemsPerPage + 1;
  const entriesEnd = Math.min(currentPage * itemsPerPage, totalRecords);
  const { sideNav } = colors;

  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    let newOrder = rowsData?.rows[result?.destination?.index]?.display_order;
    let updateRecord = rowsData?.rows[result?.source?.index];
    updateRecord.display_order = newOrder;
    const response = await updateApi(updateRecord);
    if (response.status === 200) {
      getDataList();
    }
  };

  useEffect(() => {
    if (getDataList && isDraggable) {
      getDataList(defaultFilter);
    }
  }, [defaultFilter]);

  const handleSortChange = (col) => {
    setDefaultFilter((prevState) => {
      const existingSortBy = prevState?.sortBy.find((sort) => sort?.id === col);

      let updatedSortBy;

      if (!existingSortBy) {
        updatedSortBy = [{ id: col, value: "asc" }];
      } else if (existingSortBy?.value === "asc") {
        updatedSortBy = [{ id: col, value: "desc" }];
      } else {
        updatedSortBy = [];
      }

      return { ...prevState, sortBy: updatedSortBy };
    });
  };
  const [defaultFilterIcon, setDefaultFilterIcon] = useState([]);

  const defaultFilterIconHideShow = (index) => {
    if (defaultFilterIcon?.indexOf(index) >= 0) {
      setDefaultFilterIcon(defaultFilterIcon?.filter((item) => item !== index));
    } else {
      setDefaultFilterIcon([index]);
    }
  };

  return (
    // <TableContainer sx={{ boxShadow: "none" }}>
    //   {entriesPerPage || canSearch ? (
    //     <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
    //       {entriesPerPage && (
    //         <MDBox display="flex" alignItems="center">
    //           <Autocomplete
    //             disableClearable
    //             value={pageSize.toString()}
    //             options={entries}
    //             onChange={(event, newValue) => {
    //               setEntriesPerPage(parseInt(newValue, 10));
    //             }}
    //             size="small"
    //             sx={{ width: "5rem" }}
    //             renderInput={(params) => <MDInput {...params} />}
    //           />
    //           <MDTypography variant="caption" color="secondary">
    //             &nbsp;&nbsp;entries per page
    //           </MDTypography>
    //         </MDBox>
    //       )}
    //       {canSearch && (
    //         <MDBox width="12rem" ml="auto">
    //           <MDInput
    //             placeholder="Search..."
    //             value={search}
    //             size="small"
    //             fullWidth
    //             onChange={({ currentTarget }) => {
    //               setSearch(search);
    //               onSearchChange(currentTarget.value);
    //             }}
    //           />
    //         </MDBox>
    //       )}
    //     </MDBox>
    //   ) : null}
    //   <Table {...getTableProps()}>
    //     <MDBox component="thead">
    //       {headerGroups.map((headerGroup, key) => (
    //         <TableRow key={key} {...headerGroup.getHeaderGroupProps()}>
    //           {headerGroup.headers.map((column, idx) => (
    //             <DataTableHeadCell
    //               key={idx}
    //               {...column.getHeaderProps(isSorted && column.getSortByToggleProps())}
    //               width={column.width ? column.width : "auto"}
    //               align={column.align ? column.align : "left"}
    //               sorted={setSortedValue(column)}
    //             >
    //               {column.render("Header")}
    //             </DataTableHeadCell>
    //           ))}
    //         </TableRow>
    //       ))}
    //     </MDBox>
    //     <TableBody {...getTableBodyProps()}>
    //       {page.map((row, key) => {
    //         prepareRow(row);
    //         return (
    //           <TableRow key={key} {...row.getRowProps()}>
    //             {row.cells.map((cell, idx) => (
    //               <DataTableBodyCell
    //                 key={idx}
    //                 noBorder={noEndBorder && rows.length - 1 === key}
    //                 align={cell.column.align ? cell.column.align : "left"}
    //                 {...cell.getCellProps()}
    //               >
    //                 {cell.render("Cell")}
    //               </DataTableBodyCell>
    //             ))}
    //           </TableRow>
    //         );
    //       })}
    //     </TableBody>
    //   </Table>

    //   <MDBox
    //     display="flex"
    //     flexDirection={{ xs: "column", sm: "row" }}
    //     justifyContent="space-between"
    //     alignItems={{ xs: "flex-start", sm: "center" }}
    //     p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
    //   >
    //     {showTotalEntries && (
    //       <MDBox mb={{ xs: 3, sm: 0 }}>
    //         <MDTypography variant="button" color="secondary" fontWeight="regular">
    //           Showing {entriesStart} to {entriesEnd} of {rows.length} entries
    //         </MDTypography>
    //       </MDBox>
    //     )}
    //     {pageOptions.length > 1 && (
    //       <MDPagination
    //         variant={pagination.variant ? pagination.variant : "gradient"}
    //         color={pagination.color ? pagination.color : "info"}
    //       >
    //         {canPreviousPage && (
    //           <MDPagination item onClick={() => previousPage()}>
    //             <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
    //           </MDPagination>
    //         )}
    //         {renderPagination.length > 6 ? (
    //           <MDBox width="5rem" mx={1}>
    //             <MDInput
    //               inputProps={{ type: "number", min: 1, max: customizedPageOptions.length }}
    //               value={customizedPageOptions[pageIndex]}
    //               onChange={(handleInputPagination, handleInputPaginationValue)}
    //             />
    //           </MDBox>
    //         ) : (
    //           renderPagination
    //         )}
    //         {canNextPage && (
    //           <MDPagination item onClick={() => nextPage()}>
    //             <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
    //           </MDPagination>
    //         )}
    //       </MDPagination>
    //     )}
    //   </MDBox>
    // </TableContainer>
    <TableContainer sx={{ boxShadow: `${sideNav.boxShadowTwo}` }}>
      <MDBox
        style={{ display: "flex", alignItems: "center", paddingLeft: "20px", paddingTop: "20px" }}
      >
        {tableTitle && (
          <h3
            style={{
              fontWeight: "700",
              fontSize: "18px",
              lineHeight: "21px",
              color: `${sideNav.textColor}`,
            }}
          >
            {tableTitle}
          </h3>
        )}
        {/* {canSearch && (
          <MDBox
            width="12rem"
            ml="auto"
            pl={1}
            pr={4}
            pt={4}
            sx={{ position: "absolute", right: "16px" }}
          >
            <MDInput
              placeholder="Search here"
              value={search}
              size="small"
              fullWidth
              onChange={({ currentTarget }) => {
                setSearch(search);
                onSearchChange(currentTarget.value);
              }}
              sx={{
                color: "#344767",
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "17px",
              }}
            />
          </MDBox>
        )} */}
      </MDBox>
      {(showEntriesPerPage && showRowPaginationOptions) || canSearch ? (
        <MDBox p={2}>
          <MDBox>
            {entriesPerPage && (
              <MDBox display="flex" alignItems="center">
                <Autocomplete
                  disableClearable
                  value={defaultFilter?.itemsPerPage.toString()}
                  options={entries}
                  // onChange={(event, newValue) => {
                  //   setEntriesPerPage(parseInt(newValue, 10));
                  // }}
                  onChange={handleEntriesChange}
                  size="small"
                  sx={{ width: "4rem" }}
                  renderInput={(params) => <MDInput {...params} />}
                />
                <MDTypography
                  variant="p"
                  fontSize="14px"
                  fontWeight="600"
                  color={sideNav.textColor}
                  sx={{ textWrap: "nowrap" }}
                >
                  &nbsp;&nbsp;&nbsp;Entries per page
                </MDTypography>
              </MDBox>
            )}
          </MDBox>
          <MDBox display="flex" alignItems="center">
            <MDBox
            // className={`table-clear_btn ${
            //   isClearAllFilter && dataFilter.some((filterVal) => Boolean(filterVal.value))
            //     ? "cc_opicity--full"
            //     : ""
            // } `}
            >
              {isClearAllFilter && (
                <Button style={customButtonStyles} onClick={(e) => clearAllFilters()}>
                  <CloseIcon sx={{ marginRight: "10px" }} />
                  clear All
                </Button>
              )}
            </MDBox>
            {/* {canFilter &&
              dataFilter &&
              dataFilter.map((filterVal) => {
                return (
                  <>
                    {filterVal.inputType === "selectbox" && (
                      <MDBox display="flex" alignItems="center" paddingRight="10px">
                        <Autocomplete
                          disableClearable
                          options={filterVal.option}
                          value={filterVal.value}
                          onChange={(event, newValue) => {
                            filterVal.handleChange(filterVal.accessor, newValue);
                          }}
                          size="small"
                          sx={{
                            width: "10rem",
                            color: "#BFC3DA",
                            padding: "0px",
                            border: "0",
                          }}
                          popupIcon={
                            <KeyboardArrowDownIcon sx={{ fontSize: "14px", width: "18px" }} />
                          }
                          renderInput={(params) => (
                            <MDInput
                              {...params}
                              label={filterVal.label}
                              variant="standard"
                              sx={{ fontWeight: "400" }}
                            />
                          )}
                        />
                      </MDBox>
                    )}
                    {filterVal.inputType === "date" && (
                      <MDBox
                        component="span"
                        className="table-date-selector"
                        style={{ minWidth: "150px" }}
                      >
                        <MDDatePicker
                          value={filterVal.value}
                          onChange={(date) => {
                            filterVal.handleChange(filterVal.accessor, date);
                          }}
                          label={filterVal.label}
                        />
                      </MDBox>
                    )}
                    {filterVal.inputType === "checkbox" && (
                      <MDBox
                        component="span"
                        className="table-date-selector"
                        style={{ minWidth: "150px" }}
                      >
                        <FormGroup>
                          <FormControlLabel
                            sx={{ userSelect: "none" }}
                            control={
                              <Checkbox
                                onChange={(e) => {
                                  filterVal.handleChange(filterVal.accessor, e.target.checked);
                                }}
                                checked={Boolean(filterVal.value)}
                              />
                            }
                            label={filterVal.label}
                          />
                        </FormGroup>
                      </MDBox>
                    )}
                  </>
                );
              })} */}
          </MDBox>
        </MDBox>
      ) : null}

      <DragDropContext onDragEnd={handleDragEnd}>
        <Table {...getTableProps()} className="dataTable">
          <MDBox component="thead">
            {/* <TableRow > */}
            <th></th>
            {headerGroups.map((headerGroup, key) => (
              <TableRow key={key} {...headerGroup.getHeaderGroupProps()} rowspan="6">
                {headerGroup.headers.map((column, idx) => {
                  if (!column) return null; // Check if column is defined
                  return (
                    <DataTableHeadCell
                      key={idx}
                      {...column.getHeaderProps()}
                      sort={column.sort ?? false}
                      // sorted={column.isSorted ? (column.isSortedDesc ? "desc" : "asc") : false}
                      onMouseEnter={() => defaultFilterIconHideShow(idx)}
                      onMouseLeave={() => defaultFilterIconHideShow(idx)}
                      className="table_th_cell"
                      // minWidth={column.minWidth || 'auto'}
                      // align={column.align || 'left'}
                      colspan={isDraggable && idx === 0 && "2"}
                      paddingLeft={isDraggable && idx === 0 ? "70px" : "24px"}
                      // otherwise add width to set thead width
                    >
                      <Box display="flex" gap="10px" alignItems="center">
                        <Box>{column.render("Header")}</Box>
                        {column?.sort && (
                          <>
                            {defaultFilter?.sortBy?.find((item) => item?.id === column?.id)
                              ?.value === "asc" && (
                              <LuArrowUp
                                style={{ fontSize: "12px", color: "#6c757d", cursor: "pointer" }}
                                onClick={() => handleSortChange(column.id)}
                              />
                            )}
                            {defaultFilter?.sortBy?.find((item) => item?.id === column?.id)
                              ?.value === "desc" && (
                              <LuArrowDown
                                style={{ fontSize: "12px", color: "#6c757d", cursor: "pointer" }}
                                onClick={() => handleSortChange(column.id)}
                              />
                            )}
                            {!defaultFilter?.sortBy?.some((item) => item?.id === column?.id) && (
                              <LuArrowUpDown
                                style={{ fontSize: "12px", color: "#6c757d", cursor: "pointer" }}
                                onClick={() => handleSortChange(column.id)}
                              />
                            )}
                          </>
                        )}
                      </Box>
                    </DataTableHeadCell>
                  );
                })}
              </TableRow>
            ))}
            {/* </TableRow> */}
          </MDBox>
          {Boolean(table?.isFilter) && (
            <TableRow>
              {
                //  filter 2...
                Boolean(table?.columns) &&
                  table?.columns?.map((item, idx) => (
                    <DataTableBodyCell
                      key={item?.id}
                      colspan={isDraggable && idx === 0 && "2"}
                      paddingLeft={isDraggable && idx === 0 ? "70px" : "24px"}
                    >
                      {item?.filterInputType === SEARCH_INPUT_TYPES.AUTO_COMPLETE && (
                        <MDBox display="flex" alignItems="center" sx={{ minWidth: "180px" }}>
                          <Autocomplete
                            options={item?.filterOption}
                            onChange={(event, newValue) => {
                              item?.filterHandleChange(item?.filterAccessor, newValue || "");
                            }}
                            size="small"
                            sx={{
                              width: "85% !important",
                              color: "#BFC3DA",
                              padding: "0px",
                              border: "0",
                            }}
                            popupIcon={
                              <KeyboardArrowDownIcon sx={{ fontSize: "14px", width: "18px" }} />
                            }
                            renderInput={(params) => (
                              <MDInput
                                {...params}
                                placeholder={item?.filterLabel}
                                variant="standard"
                                sx={{ fontWeight: "400" }}
                              />
                            )}
                          />
                        </MDBox>
                      )}
                      {item?.filterInputType === SEARCH_INPUT_TYPES.TEXT && (
                        <MDBox display="flex" alignItems="center" sx={{ minWidth: "180px" }}>
                          <Input
                            sx={{
                              fontSize: "12px",
                              padding: "10px 0px 0px 5px",
                            }}
                            type="search"
                            value={item?.filterValue}
                            onChange={(e) => {
                              item?.filterHandleChange(item?.filterAccessor, e.target.value);
                            }}
                            placeholder={item?.filterLabel}
                            inputProps={{ "aria-label": "description" }}
                          />
                        </MDBox>
                      )}
                      {item?.filterInputType === SEARCH_INPUT_TYPES.DATE && (
                        <MDBox
                          component="span"
                          className="table-date-selector"
                          sx={{
                            "@media (min-width:576px)": {
                              minWidth: "180px",
                              margin: "0 !important",
                            },
                            "@media (max-width:575px)": {
                              width: "100%",
                              margin: "0 !important",
                              paddingTop: "30px !important",
                            },
                          }}
                        >
                          <MDDatePicker
                            width="70% !important"
                            value={item?.filterValue}
                            padding="10px 0px 6px 5px"
                            onChange={(date) => {
                              item?.filterHandleChange(item?.filterAccessor, date);
                            }}
                            // label={item?.filterLabel}
                          />
                        </MDBox>
                      )}
                      {item?.filterInputType === SEARCH_INPUT_TYPES.TIME && (
                        <MDBox
                          component="span"
                          className="table-date-selector"
                          sx={{
                            "@media (min-width:576px)": {
                              minWidth: "180px",
                              margin: "0 !important",
                            },
                            "@media (max-width:575px)": {
                              width: "100%",
                              margin: "0 !important",
                              paddingTop: "30px !important",
                            },
                          }}
                        >
                          <MDTimePicker
                            width="70% !important"
                            value={item?.filterValue}
                            padding="10px 0px 6px 5px"
                            onChange={(time) => {
                              item?.filterHandleChange(item?.filterAccessor, time);
                            }}
                            // label={item?.filterLabel}
                          />
                        </MDBox>
                      )}
                    </DataTableBodyCell>
                  ))
              }
            </TableRow>
          )}
          <Droppable droppableId="table-rows">
            {(provided) => (
              <TableBody
                {...getTableBodyProps()}
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {page.map((row, index) => {
                  prepareRow(row); // Ensure prepareRow is called for each row
                  return (
                    <Draggable key={row.id} draggableId={row.id} index={index}>
                      {(provided, snapshot) => (
                        <TableRow
                          {...row.getRowProps()}
                          {...provided.draggableProps}
                          ref={provided.innerRef}
                        >
                          {isDraggable && (
                            <td align="center" {...provided.dragHandleProps}>
                              <MdDragIndicator />
                            </td>
                          )}

                          {row.cells.map((cell, index) => (
                            <DataTableBodyCell
                              noBorder={noEndBorder && rows.length - 1 === index}
                              align={cell.column.align ? cell.column.align : "left"}
                              {...cell.getCellProps()}
                              key={index}
                              sx={{ paddingTop: 0, paddingBottom: 0 }}
                            >
                              {cell.render("Cell")}
                            </DataTableBodyCell>
                          ))}
                        </TableRow>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </TableBody>
            )}
          </Droppable>
        </Table>
      </DragDropContext>

      {page?.length === 0 && (
        <MDBox
          color={sideNav.textColor}
          fontWeight="500"
          fontSize="20px"
          style={{
            width: "100%",
            display: "block",
            textAlign: "center",
            paddingTop: "24px",
          }}
        >
          No records found!
        </MDBox>
      )}

      <MDBox
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        p={!showTotalEntries && pageOptions.length === 1 ? 0 : 3}
      >
        {showTotalEntries && (
          <MDBox mb={{ xs: 3, sm: 0 }} paddingTop={`${rows?.length === 0 && "0px"}`}>
            <MDTypography variant="button" color="secondary" fontWeight="regular">
              Showing {entriesStart} to {entriesEnd} of {totalRecords} entries
            </MDTypography>
          </MDBox>
        )}

        {rowCount > defaultFilter?.itemsPerPage && showRowPaginationOptions && (
          <Pagination
            count={Math.ceil(rowCount / defaultFilter?.itemsPerPage)}
            color="info"
            page={currentPage}
            onChange={handlePageChange}
            hidePrevButton={defaultFilter?.currentPage === 1}
            hideNextButton={
              defaultFilter?.currentPage === Math.ceil(rowCount / defaultFilter?.itemsPerPage)
            }
            sx={{
              position: "absolute",
              right: "40px",
              "& .MuiPaginationItem-root": {
                height: "36px",
                width: "36px",
                fontSize: "16px",
                borderRadius: "50%",
                border: "1px solid #7b809a",
                "&.Mui-selected": {
                  background: `${info.main} !important`,
                  color: "#FFFFFF",
                  cursor: "default",
                },
              },
            }}
          />
        )}
      </MDBox>
    </TableContainer>
  );
}

// Setting default values for the props of DataTable
DataTable.defaultProps = {
  // entriesPerPage: { dataPerPage: 10, entries: [5, 10, 15, 20, 25] },
  canSearch: false,
  showTotalEntries: true,
  pagination: { variant: "gradient", color: "info" },
  isSorted: true,
  dataFilter: [],
  canFilter: false,
  noEndBorder: false,
};

// Typechecking props for the DataTable
DataTable.propTypes = {
  entriesPerPage: PropTypes.oneOfType([
    PropTypes.shape({
      dataPerPage: PropTypes.number,
      entries: PropTypes.arrayOf(PropTypes.number),
    }),
    PropTypes.bool,
  ]),
  getDataList: () => {}, // Default no-op function
  canSearch: PropTypes.bool,
  showTotalEntries: PropTypes.bool,
  table: PropTypes.objectOf(PropTypes.array).isRequired,
  pagination: PropTypes.shape({
    variant: PropTypes.oneOf(["contained", "gradient"]),
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
    ]),
  }),
  isSorted: PropTypes.bool,
  noEndBorder: PropTypes.bool,
  tableTitle: PropTypes.string,
  canFilter: PropTypes.bool,
  isClearAllFilter: PropTypes.bool,
  clearAllFilters: PropTypes.func,
};

export default DataTable;
